/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';
import { withFocusable } from '@noriginmedia/react-spatial-navigation';
import { compose } from 'redux';
import { getDisplayName } from './utils';

export function withFocusableClassName(WrappedComponent) {
  function WithFocusableClassName({ className = '', ...props }) {
    return (
      <WrappedComponent className={`dtv-html5-s-focusable ${className}`} {...props} />
    );
  }

  WithFocusableClassName.propTypes = {
    className: PropTypes.string,
  };

  WithFocusableClassName.displayName = `WithFocusableClassName(${getDisplayName(WrappedComponent)})`;

  return memo(WithFocusableClassName);
}

export default function withClassNameFocusable(options) {
  return compose(
    withFocusable(options),
    withFocusableClassName,
  );
}
